import { IAdminClub } from '../admin/clubs/store';

export interface IClubInvitation {
  accepted: boolean;
  club: IAdminClub;
  email: string;
  event: number | null;
  expired: boolean;
  id: number;
  is_guest: boolean;
  key: string;
  match: boolean;
  sent: string;
}

export interface IClubInvitationsStore {
  invitations: IClubInvitation[];
}
export const clubInvitationsStore: IClubInvitationsStore = { invitations: [] };
